<template>
  <div>
    <!--<notification-message class="notification" />-->
    <!-- start table of history-->
    <div class="crudArray">
      <CrudDataTable
        :con="con"
        :items="bookings"
        :hideBtn="true"
        :hideEdit="true"
        :footer-props="{
          'items-per-page-options': [5, 10, 15, 20],
          showFirstLastPage: true,
        }"
      >
        <template v-slot:[`moreActions`]="{ item }">
          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-icon small v-on="on" @click="($event) => goToDetails(item)">
                mdi-information
              </v-icon>
            </template>
            <span>{{ $t("crudCommon.tooltipDetails") }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.dateStart`]="{ item }">
          <span>{{ new Date(item.dateStart).toLocaleString("fr-FR") }}</span>
        </template>
        <template v-slot:[`item.dateEnd`]="{ item }">
          <span>{{ new Date(item.dateEnd).toLocaleString("fr-FR") }}</span>
        </template>
        <template v-slot:[`item.user.firstName`]="{ item }">
          <span>{{ `${item.user.lastName} ${item.user.firstName}` }}</span>
        </template>
      </CrudDataTable>
    </div>
    <!-- end table of history-->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import CrudDataTable from "../CrudDataTable";
import DetailBookingDialog from "@/components/components-salles/admin/crud/booking-history/DetailBookingDialog.vue";
import CrudBookingsTable from "@/models/crud/CrudBookingsTable";
import NotificationMessage from "@/components/components-base/notification/NotificationMessage.vue";
import i18n from "@/i18n";

export default {
  name: "CrudBookings",
  components: {
    CrudDataTable,
    NotificationMessage,
    DetailBookingDialog,
  },
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    ...mapGetters("bookingModule", {
      bookings: "getBookings",
      bookingsByResource: "getBookingsByResource",
    }),
    con() {
      const _con = {
        ...CrudBookingsTable,
        crud: {
          indexOf: (item) => {
            return this.bookings.indexOf(item);
          },
          delete: (item) => {
            return this.deleteButton(item);
          },
        },
      };
      return _con;
    },
  },
  methods: {
    ...mapActions("bookingModule", [
      "loadBookingsWithDependents",
      "deleteBooking",
    ]),
    goToDetails(bookings) {
      this.emptyErrorMessages();
      this.errors = false;
      this.detailIndex = this.con.crud.indexOf(bookings);
      this.detailItem = bookings;
      this.$refs.editDialog.open();
    },

    editDate() {},
  },
  async mounted() {
    await this.loadBookingsWithDependents();
  },
};
</script>

<style lang="scss" scoped>
.c {
  margin: 0 1rem;
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
}

.notification {
  width: 100%;
  height: 100%;
  position: absolute;
  padding: 3% 11%;
}

.crudArray {
  margin: 0 auto 3rem auto;
  width: 80%;
}

.errors {
  margin: 0;
  color: red !important;
}
</style>
